import { GroupModel } from "src/app/admin/models/group.model";
import { SurveyModel } from "src/app/dashboard/dashboard.model";
import { EntityMaster } from "src/app/shared/models/entityMaster.model";

export class CreateBusinessProcessModel {
    businessProcessID: string;  
    businessProcessName: string;  
    businessProcessDescription: string; 
    businessProcessShortText: string;   
    businessProcessGroupRelModel :BusinessProcessGroupRelModel;
    status : string;
    logoFormat: string = "";
    logoImage: string = "";
    logoSize:number;
    groupMasterModel: GroupModel[]=[];
    surveyModel : SurveyModel;
    SurveyModel:SurveyModel;
    surveyId:string;
    createdDate :Date;
    businessProcessEntityRelModel : BusinessProcessEntityRelModel[];
    entityMasters : EntityMaster[]=[];
    isWorkFlowExists :boolean;
  }
  
  export class BusinessProcessGroupRelModel {
    businessProcessID: string; 
    groupId: string;  
  }

  export class BusinessProcessEntityRelModel {
    businessProcessID: string; 
    entityIDs: string[]=[];
    isDeleted: boolean;    
  }